<template>
  <div>
    <infinite-loading
      v-if="top"
      direction="top"
      :key="'isc' + key"
      :identifier="infiniteId"
      @infinite="showMoreListItem"
      :forceUseInfiniteWrapper="forceUseInfiniteWrapper"
      :distance="distance"
    >
      <div slot="no-more"></div>
      <div slot="no-results"></div>
      <div slot="error"></div>
    </infinite-loading>
    <slot :items="itemsToDisplay"></slot>
    <infinite-loading
      v-if="!top"
      :key="'isc' + key"
      :identifier="infiniteId"
      @infinite="showMoreListItem"
      :forceUseInfiniteWrapper="forceUseInfiniteWrapper"
      :distance="distance"
    >
      <div slot="no-more"></div>
      <div slot="no-results"></div>
      <div slot="error"></div>
    </infinite-loading>
  </div>
</template>

<script>
import $ from 'jquery';
import InfiniteLoading from 'vue-infinite-loading';
import { FIREFOX_MAX_SAFE_INT_V_43, scrollToPos } from '../../utils/common';
export default {
  name: 'infinity-scroll-list',
  data() {
    return {
      visibleListItems: 8,
      infiniteId: +new Date(),
      scrollTopBtn: false,
      key: 0,
    };
  },
  created() {
    this.resetVisibleItems();
  },
  activated() {
    this.key++;
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    showMoreListItem($state) {
      if (this.visibleListItems < this.items.length) {
        this.visibleListItems += 5;
        $state.loaded();
      } else {
        $state.complete();
      }
      // this.$nextTick(() => {
      //   this.scrollTopBtn = this.$root.$el.scrollHeight > window.innerHeight;
      // });
    },
    resetVisibleItems() {
      this.visibleListItems = this.initItemLength;
      this.infiniteId += 1;
      if (this.scrollAfterReset) {
        scrollToPos($(this.$el).closest('.ps'), {
          top: this.top ? FIREFOX_MAX_SAFE_INT_V_43 : 0,
        });
      }
    },
    async ShowAll() {
      this.visibleListItems = this.items.length;
      this.infiniteId += 1;
      await this.$nextTick();
    },
  },
  computed: {
    itemsToDisplay() {
      if (this.top) {
        let items = this.items.slice(0, this.visibleListItems);
        items.reverse();
        return items;
      }
      return this.items.slice(0, this.visibleListItems);
    },
  },
  watch: {
    items: {
      handler: function(params) {
        if (this.autoResetVisibleItems) {
          this.resetVisibleItems();
        } else {
          this.infiniteId += 1;
        }
      },
    },
  },
  components: {
    InfiniteLoading,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    forceUseInfiniteWrapper: {
      default: false,
    },
    distance: {
      type: Number,
      default: 350,
    },
    initItemLength: {
      type: Number,
      default: 8,
    },
    autoResetVisibleItems: {
      type: Boolean,
      default: false,
    },
    scrollAfterReset: {
      type: Boolean,
      default: true,
    },
    top: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss"></style>
